import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgBadgeComponent } from './pg-badge.component';
import { PgIconModule } from '../pg-icon/pg-icon.module';
import { PgBadgeProgressIndicatorComponent } from './pg-badge-progress-indicator/pg-badge-progress-indicator.component';
import { PgBadgeFactoryComponent } from './pg-badge-factory/pg-badge-factory.component';

@NgModule({
  imports: [CommonModule, PgIconModule],
  declarations: [
    PgBadgeComponent,
    PgBadgeProgressIndicatorComponent,
    PgBadgeFactoryComponent,
  ],
  exports: [PgBadgeComponent, PgBadgeFactoryComponent],
})
export class PgBadgeModule {}
